import { useState, useEffect } from 'react';
import {useSelector} from 'react-redux'
import api from '../api/api';


const useLevels = (token) => {
    const [levels, setLevels] = useState([]);
    const _token = useSelector((state) => state.token);
  const [loading , setLoading] = useState(false);

    const LevelSetter = (val)=>{
        let value = null
        levels.forEach((el)=>{
          if(el.value === val ){
            value = el.text;
          }
        })
        return value;
      }
    useEffect(() => {
      
if (token || _token)  {
  setLoading(true)
  const fetchToken = token ? token : _token;
  api.get('/levels', { headers: { Authorization: "Token " + fetchToken } }).then((res) => {
    const data = Array.isArray(res.data) ? res.data.map((level)=>{
      return {
        value : level.id,
        text : level.name,
        order : level.order
      }
    })
    .sort((a , b)=>{
      if (a.order > b.order) {
        return 1
      }
      if (a.order < b.order) {
        return -1
      }
      return 0
    })
    : []
    setLevels(data)
    setLoading(false)
    }).catch(() => {
      setLoading(false)
     })
}
      


    }, []);

    return { levels , LevelSetter , loading };
};

export default useLevels;